import { Subscription } from 'rxjs/internal/Subscription';

export class AOSubscriptions {

  /**
   * @return any
   */
  constructor() {
    const handler = {
      set(obj, prop, value) {
        if (obj[prop] && obj[prop].unsubscribe) {
          obj[prop].unsubscribe();
        }

        Reflect.set(obj, prop, value);

        return value;
      }
    };

    return new Proxy(this, handler);
  }

  readonly add = (name: string, subscription: Subscription) => {
    this[name] = subscription;
    return this;
  };

  readonly stop = (names: string[] = null) => {
    Object.keys(this).filter(name => ['add', 'stop'].indexOf(name) == -1).forEach(name => {
      if (names === null || names.indexOf(name + '') >= 0) {
        this[name].unsubscribe();
      }
    });

    return this;
  };

  // private subscriptions = {};
  //
  // add(name: string, subscription: Subscription) {
  //   if (this.subscriptions[name]) {
  //     this.subscriptions[name].unsubscribe();
  //   }
  //
  //   this.subscriptions[name] = subscription;
  //
  //   return subscription;
  // }
  //
  // stop = (names: string[] = null) => {
  //   Object.keys(this.subscriptions).forEach(name => {
  //     if (names === null || names.indexOf(name + '') >= 0) {
  //       this.subscriptions[name].unsubscribe();
  //     }
  //   });
  //
  //   return this;
  // };

}
